// sx props for SelectClient page components
// Must use sx props to style the TrackableButtons; styles in a module.scss file won't work
// with our TrackableButton (mui).
// Shared sx styles for header buttons (Back/Logout).
export const headerButtonSx = {
    all: 'unset',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem 0',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 500,
    color: 'var(--off-black, #170b01)',
    background: 'transparent',
    '&:hover': { opacity: 0.7, background: 'transparent' },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.5 },
};
// Base sx styles for workspace cards
const getWorkspaceCardSx = (options) => ({
    all: 'unset',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.25rem 1.5rem',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    width: '100%',
    textAlign: 'left',
    overflow: 'hidden',
    boxSizing: 'border-box',
    background: options.isLoading ? '#f8fafc' : options.defaultBackground,
    border: `1px solid ${options.defaultBorderColor}`,
    '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '3px',
        backgroundColor: options.accentColor,
    },
    '&:hover': {
        backgroundColor: 'var(--secondary-color-engaged, rgba(23, 11, 1, 0.2))',
        '& [class*="cardTitle"]': { fontWeight: 700 },
    },
    '&:active': { transform: 'scale(0.99)' },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.7 },
});
// Employee card (Submit expenses) - white background, light border, mint accent
export const getEmployeeCardSx = (isLoading) => getWorkspaceCardSx({
    isLoading,
    defaultBackground: 'white',
    defaultBorderColor: 'var(--divider-color-opacity-1, #170b011a)',
    accentColor: 'var(--mint, #abe69e)',
});
// Approver card - transparent background, dark border, neutral accent
export const getApproverCardSx = (isLoading) => getWorkspaceCardSx({
    isLoading,
    defaultBackground: 'none',
    defaultBorderColor: 'var(--off-black, #170b01)',
    accentColor: 'var(--background-color-1, #d7d1bd)',
});
